import styled from "styled-components";
import { DefaultParagraphLargeFactory, DefaultParagraphSmallFactory, DefaultTitleLargeFactory } from "../Typograph/Typograph.Style";

export const SectionTitle = styled.h2(({ theme }) => ({
    ...DefaultTitleLargeFactory({ theme })
}))

export const SectionSubTitle = styled.p(({ theme }) => ({
    ...DefaultParagraphLargeFactory({ theme }),
    fontWeight: 500,
}))

export const SectionParagraph = styled.p(({ theme }) => ({
    ...DefaultParagraphLargeFactory({ theme })
}))

export const ContactParagraph = styled.p(({ theme }) => ({
    ...DefaultParagraphSmallFactory({ theme }),
    fontWeight: 400
})) 

export const ContactCard = styled.div(({ theme }) => ({
    padding: '16px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,

    [theme.breakpoint.md()]: {
        padding: "24px 16px",
    }
}))

export const ContactContent = styled.div(() => ({
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    justifyContent: "center"
}))

export const ContactContainer = styled.div(({ theme }) => ({
    [theme.breakpoint.lg()]: {
        display: 'flex',
        gap: 20
    }
}))

export const Container = styled.div(({ theme }) => ({
    display: 'block',

    [theme.breakpoint.lg()]: {
        display: 'flex',
        gap: 136
    }
}))

export const FirstColumn = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column-reverse',
    gap: 16,

    [theme.breakpoint.lg()]: {
        width: '384px',
        flexDirection: 'column',
        gap: 32
    }
}))

export const SecondColumn = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 16,

    [theme.breakpoint.lg()]: {
        width: '696px',
        gap: 32,
    }
}))

export const CoverMobile = styled.div(({ theme }) => ({
    display: 'block',

    [theme.breakpoint.lg()]: {
        display: 'none'
    }
}))

export const CoverDesk = styled.div(({ theme }) => ({
    display: 'none',

    [theme.breakpoint.lg()]: {
        display: 'block'
    }
}))